export const CANCEL_FLOW_VERSIONS = ["v3", "v4"] as const;

export type CancelFlowVersion = (typeof CANCEL_FLOW_VERSIONS)[number];

interface UserWithCreatedDt {
  createdDt?: number;
}

export const getCancelFlowVersionFromUser = (
  user: UserWithCreatedDt | null | undefined,
): CancelFlowVersion => {
  if (user == null || typeof user.createdDt !== "number") {
    return "v3";
  }

  return user.createdDt % 2 === 0 ? "v4" : "v3";
};
